export default {
    promisesOrders: [],
    promisesRequests: [],
}